import { CheckRounded, GetApp as GetAppIcon } from '@mui/icons-material';
import { CircularProgress, IconButton, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useLatestTemplateVersion } from '~/hooks/forms/useLatestTemplateVersion';
import { FormioFormBuilderConfig } from '~/types/forms';

import { useStyles } from './useStyles';

type Props = {
  updated: boolean;
  formId: string;
  disableAction?: boolean;
  marginLeft?: string;
  loading?: boolean;
  onVersionUpdated?: (updateTemplate: FormioFormBuilderConfig) => void;
};

export const TemplateUpdateIconBtns = (props: Props) => {
  const {
    updated,
    formId,
    disableAction,
    marginLeft,
    loading,
    onVersionUpdated,
  } = props;
  const sxStyles = useStyles();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { updateTemplateVersion, isValidating: updating } =
    useLatestTemplateVersion();

  const [updateSuccess, setUpdateSuccess] = useState<boolean>();

  const handleClick = () => {
    if (!disableAction) {
      updateTemplateVersion(formId)
        .then((data: FormioFormBuilderConfig) => {
          enqueueSnackbar(t('success'), { variant: 'success' });
          setUpdateSuccess(true);
          if (onVersionUpdated) {
            onVersionUpdated(data);
          }
        })
        .catch((err) => {
          console.log(err);
          enqueueSnackbar(t('fError_unableToUpdateTemplate'), {
            variant: 'error',
          });
          setUpdateSuccess(false);
        });
    }
  };

  if (loading || updating) {
    return (
      <Typography component="span" sx={sxStyles.loader} style={{ marginLeft }}>
        <CircularProgress size={22} />
      </Typography>
    );
  }

  if (!updated && disableAction) {
    return (
      <Typography color="error" title="fTemplateOutdatedInfo">
        {t('fTemplateOutdated')}
      </Typography>
    );
  }

  return updated || updateSuccess ? (
    <IconButton
      title={t('fTemplateLatest')}
      style={{
        color: '#28a745',
        ...(marginLeft && { marginLeft: '20px' }),
      }}
    >
      <CheckRounded />
    </IconButton>
  ) : (
    <IconButton
      aria-label="update"
      color="secondary"
      onClick={handleClick}
      title={t('fTemplateOutdated')}
      sx={sxStyles.downloadButton}
      style={{
        ...(marginLeft && { marginLeft: '20px' }),
      }}
    >
      <GetAppIcon />
    </IconButton>
  );
};
